module.exports = __webpack_public_path__ + "static/media/mucen.f6db7f5d.png";